import { useSelector } from "react-redux";

import { AccountSettings } from "@akj-dev/affinity-platform";

import { getAccountSettings } from "../../store/account/selectors";

export const useCanAccessVfDirect = () => {
  const accountSettings = useSelector<any, AccountSettings>(getAccountSettings);

  return accountSettings.can_access_vf_direct === "1";
};
